import { useCallback, useMemo } from 'react';

import { IcDoneIcon } from '@gem/icons';

import { IPopover } from '../../../Popover/Popover.types';
import { usePopover } from '../../../Popover/usePopover';
import { defaultVideoPlayerConfig } from '../VideoPlayer.constants';

export interface IVideoPlayerSpeedProps {
  currentSpeed: number;
  onSpeedChange(speed: number): void;
  onToggleSpeedPopover(isToggled: boolean): void;
  normalSpeedText?: string;
}

interface IVideoPlayerSpeedPresenterParams extends IVideoPlayerSpeedProps {}

interface IVideoPlayerSpeedPresenter {
  menuItems: any[];
  popover: IPopover<HTMLButtonElement>;
  togglePopover(): void;
  closePopover(): void;
}

const SPEED_OPTIONS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

export function useVideoPlayerSpeedPresenter(
  params: IVideoPlayerSpeedPresenterParams
): IVideoPlayerSpeedPresenter {
  const { currentSpeed, onSpeedChange, onToggleSpeedPopover, normalSpeedText } = params;
  const popover = usePopover<HTMLButtonElement>();

  const togglePopover = useCallback(() => {
    popover.toggle();
    if (onToggleSpeedPopover) {
      onToggleSpeedPopover(!popover.isOpened);
    }
  }, [popover.isOpened, onToggleSpeedPopover]);

  const closePopover = useCallback(() => {
    popover.close();
    if (onToggleSpeedPopover) {
      onToggleSpeedPopover(false);
    }
  }, [popover.isOpened, onToggleSpeedPopover]);

  const menuItems = useMemo(() => {
    return SPEED_OPTIONS.map((speed) => ({
      key: speed,
      title: speed === defaultVideoPlayerConfig.speed && normalSpeedText ? normalSpeedText : speed,
      onClick: (): void => onSpeedChange(speed),
      icon: speed === currentSpeed ? IcDoneIcon : null,
    }));
  }, [currentSpeed, onSpeedChange]);

  const presenter = {
    menuItems,
    popover,
    togglePopover,
    closePopover,
  };

  return presenter;
}
